module.exports = __webpack_public_path__ + "img/advertising.b7088da7.png";